import React from "react";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import InputMask from "react-input-mask";

const MASKS = {
  phone: "(99) 99999-9999",
  cnpj: "99.999.999/9999-99",
};

// Componente compartilhado entre o modal do card (BoardCardModal) e a
// tela de criar card (pages/Boards) - antes cada um tinha sua propria
// copia colada do mesmo TextField, sem mascara nenhuma pra telefone/CNPJ
// (pedido do usuario 2026-08-27). react-input-mask ja estava instalado
// mas nunca tinha sido usado em lugar nenhum do frontend.
const CardFieldInput = ({ def, value, onChange }) => {
  const mask = MASKS[def.type];

  if (mask) {
    return (
      <InputMask
        mask={mask}
        maskChar={null}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
      >
        {(inputProps) => (
          <TextField
            {...inputProps}
            label={def.name}
            fullWidth
            margin="dense"
            variant="outlined"
          />
        )}
      </InputMask>
    );
  }

  return (
    <TextField
      label={def.name}
      select={def.type === "select"}
      type={def.type === "date" ? "date" : def.type === "datetime" ? "datetime-local" : def.type === "number" ? "number" : "text"}
      multiline={def.type === "textarea"}
      minRows={def.type === "textarea" ? 3 : undefined}
      fullWidth
      margin="dense"
      variant="outlined"
      InputLabelProps={def.type === "date" || def.type === "datetime" ? { shrink: true } : undefined}
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
    >
      {def.type === "select" &&
        (def.options || []).map((opt) => (
          <MenuItem key={opt} value={opt}>
            {opt}
          </MenuItem>
        ))}
    </TextField>
  );
};

export default CardFieldInput;
